export const Marquee = ({ items }) => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden bg-[#2D1810] border-y border-[#D4AF37]/25 py-5"
  >
    <div className="marquee-track flex w-max items-center">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center shrink-0">
          {items.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="mx-8 text-xs sm:text-sm font-semibold uppercase tracking-[0.3em] text-[#F5F2EC]/70">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-[#D4AF37]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
